import { render } from "./LimitedsDeposit.vue?vue&type=template&id=1b72b76c&scoped=true"
import script from "./LimitedsDeposit.vue?vue&type=script&lang=js"
export * from "./LimitedsDeposit.vue?vue&type=script&lang=js"

import "./LimitedsDeposit.vue?vue&type=style&index=0&id=1b72b76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b72b76c"]])

export default __exports__